import jsWorkshopImgUrl from '../../../images/portfolio/web-images/js-webapp/js-workshop.jpg';
import musicPlayerImgUrl from '../../../images/portfolio/web-images/js-webapp/music-player.jpg';
import simpleCalculatorImgUrl from '../../../images/portfolio/web-images/js-webapp/simple-calculator.jpg';
import quoteGeneratorImgUrl from '../../../images/portfolio/web-images/js-webapp/quote-generator.jpg';
import carouselImgUrl from '../../../images/portfolio/web-images/js-webapp/carousel.jpg';
import colorsPanelMenuImgUrl from '../../../images/portfolio/web-images/js-webapp/colors-panel-menu.jpg';
import countdownTimerImgUrl from '../../../images/portfolio/web-images/js-webapp/countdown-timer.jpg';
import stopwatchImgUrl from '../../../images/portfolio/web-images/js-webapp/stopwatch.jpg';
import analogClockImgUrl from '../../../images/portfolio/web-images/js-webapp/analog-clock.jpg';
import digitalClockImgUrl from '../../../images/portfolio/web-images/js-webapp/digital-clock.jpg';
import modalImgUrl from '../../../images/portfolio/web-images/js-webapp/modal.jpg';

const jsTemplateList = [
  {
    imgUrl: jsWorkshopImgUrl,
    title: 'JS Workshop',
    githubUrl: 'https://github.com/amrsaadabdallah/my-js-workshop',
    infoUrl: 'https://github.com/amrsaadabdallah/js-workshop',
    liveUrl: 'https://amrsaadabdallah.github.io/js-workshop',
    type: 'large',
  },
  {
    imgUrl: musicPlayerImgUrl,
    title: 'Music Player',
    githubUrl: 'https://github.com/amrsaadabdallah/my-music-player',
    infoUrl: 'https://github.com/amrsaadabdallah/music-player',
    liveUrl: 'https://amrsaadabdallah.github.io/music-player',
    type: 'small',
  },
  {
    imgUrl: simpleCalculatorImgUrl,
    title: 'Simple Calculator',
    githubUrl: 'https://github.com/amrsaadabdallah/my-simple-calculator',
    infoUrl: 'https://github.com/amrsaadabdallah/simple-calculator',
    liveUrl: 'https://amrsaadabdallah.github.io/simple-calculator',
    type: 'small',
  },
  {
    imgUrl: quoteGeneratorImgUrl,
    title: 'Quote Generator',
    githubUrl: 'https://github.com/amrsaadabdallah/my-quote-generator',
    infoUrl: 'https://github.com/amrsaadabdallah/quote-generator',
    liveUrl: 'https://amrsaadabdallah.github.io/quote-generator',
    type: 'small',
  },
  {
    imgUrl: carouselImgUrl,
    title: 'Carousel',
    githubUrl: 'https://github.com/amrsaadabdallah/my-carousel',
    infoUrl: 'https://github.com/amrsaadabdallah/carousel',
    liveUrl: 'https://amrsaadabdallah.github.io/carousel',
    type: 'small',
  },
  {
    imgUrl: colorsPanelMenuImgUrl,
    title: 'Colors Panel Menu',
    githubUrl: 'https://github.com/amrsaadabdallah/my-colors-panel-menu',
    infoUrl: 'https://github.com/amrsaadabdallah/colors-panel-menu',
    liveUrl: 'https://amrsaadabdallah.github.io/colors-panel-menu',
    type: 'small',
  },
  {
    imgUrl: countdownTimerImgUrl,
    title: 'Countdown Timer',
    githubUrl: 'https://github.com/amrsaadabdallah/my-countdown-timer',
    infoUrl: 'https://github.com/amrsaadabdallah/countdown-timer',
    liveUrl: 'https://amrsaadabdallah.github.io/countdown-timer',
    type: 'small',
  },
  {
    imgUrl: stopwatchImgUrl,
    title: 'Stopwatch',
    githubUrl: 'https://github.com/amrsaadabdallah/my-stopwatch',
    infoUrl: 'https://github.com/amrsaadabdallah/stopwatch',
    liveUrl: 'https://amrsaadabdallah.github.io/stopwatch',
    type: 'small',
  },
  {
    imgUrl: analogClockImgUrl,
    title: 'Analog Clock',
    githubUrl: 'https://github.com/amrsaadabdallah/my-analog-clock',
    infoUrl: 'https://github.com/amrsaadabdallah/analog-clock',
    liveUrl: 'https://amrsaadabdallah.github.io/analog-clock',
    type: 'small',
  },
  {
    imgUrl: digitalClockImgUrl,
    title: 'Digital Clock',
    githubUrl: 'https://github.com/amrsaadabdallah/my-digital-clock',
    infoUrl: 'https://github.com/amrsaadabdallah/digital-clock',
    liveUrl: 'https://amrsaadabdallah.github.io/digital-clock',
    type: 'small',
  },

  {
    imgUrl: modalImgUrl,
    title: 'Modal',
    githubUrl: 'https://github.com/amrsaadabdallah/my-modal',
    infoUrl: 'https://github.com/amrsaadabdallah/modal',
    liveUrl: 'https://amrsaadabdallah.github.io/modal',
    type: 'small',
  },
];

export default jsTemplateList;
